import { render } from "./coach-profile.vue?vue&type=template&id=5f01533f"
import script from "./coach-profile.vue?vue&type=script&lang=js"
export * from "./coach-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__